var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getCssClass()},[_c('router-view'),(_vm.spinnerMessage)?_c('Spinner',{attrs:{"text":_vm.spinnerMessage}}):_vm._e(),(_vm.$apollo.loading)?_c('Spinner'):_vm._e(),_c('Confirm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }